import * as React from "react";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { getEventData } from "../../../api/topicDataAPI";
import { ConvertOIDValueToString } from "../../../utils/objectConverter";
import { renderAlarmm, renderWarningg, renderNormal } from "./StatusChip";
import { TextField, Button, Box, CircularProgress, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RefreshIcon from "@mui/icons-material/Refresh";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Typography, Card, CardContent, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRefreshInterval } from "../../../contexts/RefreshIntervalContext";
import { exportAlarmHistory } from "../../../utils/alarmHistoryExporter";
import { usePageVisibility } from "../../../hooks/usePageVisibility";
import { getPlaceIdFromPathname } from "../../../utils/pathUtils";
import { useObjectData } from "../../../hooks/useLocalStorageData";
import { formatEpoch } from "../../../utils/dateUtils";
import { useSnackbar } from "../../../hooks/useSnackbar";

export default function   HistoryDataGrid() {
  const { t } = useTranslation();
  const location = useLocation();
  const [rows, setRows] = React.useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedEventType, setSelectedEventType] = useState("");

  const EVENT_TYPE_OPTIONS = [
    "POS Ünitesi",
    "Otomat Durumu",
    "Günsonu",
    "Kapı Durumu",
    "Sinyal Düzeyi",
    "Stok Seviyesi",
    "Sıcaklık",
    "Satış Durumu",
    "Nakit Üniteleri",
    "Bağlantı Durumu",
    "Reversal",
    "Başarılı Satış",
    "Başarısız Satış",
  ];
  const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();
  const { interval, isRunning } = useRefreshInterval();
  const isPageVisibility = usePageVisibility();
  const apiRef = useGridApiRef();

  // Use custom hook to get objectData from localStorage
  const objectData = useObjectData();

  // useEffect(() => {
  //   suppressResizeObserverErrors();
  // }, []);

  const columns = [
    // {
    //   field: "dtype",
    //   headerName: t("alarmHistory.dtype"),
    //   flex: 0.5,
    //   align: "center",
    //   headerAlign: "center",
    // },
    {
      field: "status",
      headerName: t("alarmHistory.status"),
      flex: 0.3,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const alarmType = params.row.alarmType;
        if (alarmType === 2) {
          return renderAlarmm(params.value, t);
        } else if (alarmType === 1) {
          return renderWarningg(params.value, t);
        } else if (alarmType === 0) {
          return renderNormal(params.value, t);
        }
        return null;
      },
    },
    {
      field: "date",
      headerName: t("alarmHistory.date"),
      flex: 0.5,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "eventName",
      headerName: t("alarmHistory.eventName"),
      flex: 0.3,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "value",
      headerName: t("alarmHistory.value"),
      flex: 0.3,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "description",
      headerName: t("alarmHistory.description"),
      flex: 2,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
              height: "100%",
              textAlign: "center",
              padding: "8px 0",
              wordBreak: "normal",
              overflowWrap: "normal",
              textOverflow: "ellipsis",
            }}
            title={params.value ?? ""}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: "details",
      headerName: t("alarmHistory.details"),
      flex: 0.7,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: "nowrap",
              overflowX: "auto",
              overflowY: "hidden",
              width: "100%",
              height: "100%",
              textAlign: "center",
              padding: "8px 0",
              wordBreak: "normal",
              overflowWrap: "normal",
            }}
          >
            {params.value}
          </div>
        );
      },
    },

    // {
    //   field: "recordDate",
    //   headerName: t("alarmHistory.recordDate"),
    //   flex: 0.6,
    //   align: "center",
    //   headerAlign: "center",
    // },
  ];

  const fetchHistory = useCallback(
    async (start, end, eventTypeFilter) => {
      setLoading(true);
      try {
        const placeId = getPlaceIdFromPathname(location.pathname);

        if (!placeId) {
          setRows([]);
          return;
        }

        let startEpoch, endEpoch;

        if (end) {
          const endDateTime = new Date(end);
          endDateTime.setHours(23, 59, 59);
          endEpoch = Math.floor(endDateTime.getTime() / 1000);
        } else {
          endEpoch = Math.floor(Date.now() / 1000);
        }

        if (start) {
          const startDateTime = new Date(start);
          startDateTime.setHours(0, 0, 0);
          startEpoch = Math.floor(startDateTime.getTime() / 1000);
        } else {
          startEpoch = endEpoch - 2592000;
        }

        const hasEventFilter = eventTypeFilter && eventTypeFilter !== "";

        let eventOid = null;
        if (hasEventFilter) {
          const matchedObj = objectData.find((obj) => obj.name === eventTypeFilter);
          eventOid = matchedObj ? matchedObj.idObject : null;
        }

        const alarmHistory = await getEventData([Number(placeId)], {
          start: startEpoch,
          end: endEpoch,
          count: hasEventFilter ? 10000 : undefined,
          event: eventOid,
        });

        if (!alarmHistory || !Array.isArray(alarmHistory)) {
          setRows([]);
          return;
        }
        const filteredWithType = alarmHistory.map((item) => {
        const matchedObj = objectData.find(
          (obj) => obj.idObject === item.event
        );
          return { ...item, type: matchedObj ? matchedObj.type : null };
        });
        const finalConverted = filteredWithType.map((item) => {
        const matchedObj = objectData.find(
          (obj) => obj.idObject === item.event
        );
        const convertedValue = ConvertOIDValueToString(
          { Type: item.type },
          item.val
        );
        const alarmStatusText =
          item.alarmType === 0
            ? t("nodeComponents.alarmHistory.statusNormal")
            : item.alarmType === 1
            ? t("nodeComponents.alarmHistory.statusWarning")
            : item.alarmType === 2
            ? t("nodeComponents.alarmHistory.statusAlarm")
            : t("nodeComponents.alarmHistory.statusUnknown");
        let description = "-";
        let detailsText = "-"; // Only OID 206
        if (
          item.diagnosticList &&
          Array.isArray(item.diagnosticList) &&
          item.diagnosticList.length > 0
        ) {
          const diags206 = item.diagnosticList.filter((d) => d.oid === 206);
          // Exclude 1001 from other diagnostics so it doesn't appear in description
          const diagsOther = item.diagnosticList.filter(
            (d) => d.oid !== 206 && d.oid !== 1001
          );

          const detailsParts = diags206
            .map((diagnostic) => {
              const diagnosticObj = objectData.find(
                (obj) => obj.idObject === diagnostic.oid
              );
              if (diagnosticObj) {
                const convertedDiagnosticValue = ConvertOIDValueToString(
                  { Type: diagnosticObj.type },
                  diagnostic.val
                );
                // Show only value for OID 206
                return `${convertedDiagnosticValue}`;
              }
              // Fallback to raw value if object not found
              return diagnostic.val != null ? String(diagnostic.val) : null;
            })
            .filter(Boolean);

          const otherParts = diagsOther
            .map((diagnostic) => {
              const diagnosticObj = objectData.find(
                (obj) => obj.idObject === diagnostic.oid
              );
              if (diagnosticObj) {
                const convertedDiagnosticValue = ConvertOIDValueToString(
                  { Type: diagnosticObj.type },
                  diagnostic.val
                );
                return `${diagnosticObj.name} = ${convertedDiagnosticValue}`;
              }
              return null;
            })
            .filter(Boolean);

          if (detailsParts.length > 0) {
            detailsText = detailsParts.join(" | ");
          }
          if (otherParts.length > 0) {
            // Show diagnostics inline separated by pipes instead of new lines
            description = otherParts.join(" | ");
          }
        }

        return {
          id: item._id,
          dtype: item.DTYPE,
          eventName: matchedObj
            ? matchedObj.name
            : t("nodeComponents.alarmHistory.unknown"),
          // Reverted: use the main converted value
          value: convertedValue,
          status: alarmStatusText,
          alarmType: item.alarmType,
          description: description,
          details: detailsText,
          date: formatEpoch(item.epoch),
          recordDate: formatEpoch(item.epoch),
        };
        });
        const filteredResult = hasEventFilter
          ? finalConverted.filter((row) => row.eventName === eventTypeFilter)
          : finalConverted;
        setRows(filteredResult);
      } finally {
        setLoading(false);
      }
    },
    [location.pathname, t, objectData]
  );

  useEffect(() => {
    if (isRunning && isPageVisibility) {
      const intervalMs = Math.max((interval || 15) * 1000, 1000);
      fetchHistory(startDate, endDate, selectedEventType);
      const intervalId = setInterval(() => fetchHistory(startDate, endDate, selectedEventType), intervalMs);
      return () => clearInterval(intervalId);
    }
  }, [fetchHistory, isRunning, interval, isPageVisibility, selectedEventType]);

  const handleFilterClick = () => {
    fetchHistory(startDate, endDate, selectedEventType);
  };

  const handleExportToExcel = () => {
    try {
      const nodeId = getPlaceIdFromPathname(location.pathname);
      const result = exportAlarmHistory(rows, columns, nodeId);

      if (result.success) {
        showSnackbar(t('nodeComponents.alarmHistory.exportSuccess', { fileName: result.fileName }), 'success');
      } else {
        showSnackbar(result.error || t('nodeComponents.alarmHistory.exportError'), 'error');
      }
    } catch (error) {
      console.error('Excel export error:', error);
      showSnackbar(t('nodeComponents.alarmHistory.downloadError'), 'error');
    }
  };

  return (
    <>
      <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
        <Card
          sx={{
            height: "100%",
            mt: 2,
            mb: 2,
            borderWidth: 2,
            borderStyle: "solid",
          }}
        >
          {" "}
          <CardContent>
            <Stack
              direction={{ xs: "column", sm: "column", md: "row" }}
              spacing={2}
              alignItems={{ xs: "flex-start", md: "center" }}
            >
              <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                {" "}
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  sx={{
                    fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.8rem" },
                    mb: { xs: 2, md: 0 },
                    marginLeft: { xs: 0, md: 33 },
                  }}
                >
                  {t("nodeComponents.alarmHistory.title")}
                </Typography>
              </Box>
              <Box sx={{ flexGrow: 1, display: { xs: "none", md: "block" } }} />
              <Stack
                direction={{ xs: "column", sm: "column", md: "row" }}
                spacing={2}
                alignItems={{ xs: "stretch", md: "center" }}
                width={{ xs: "100%", md: "auto" }}
              >
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  width="100%"
                  justifyContent="space-between"
                >
                  <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
                    <TextField
                      label={t("nodeComponents.alarmHistory.startDate")}
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      fullWidth
                    />
                  </Box>
                  <Box sx={{ width: { xs: "100%", sm: "48%" } }}>
                    <TextField
                      label={t("nodeComponents.alarmHistory.endDate")}
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                      fullWidth
                    />
                  </Box>
                </Stack>

                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  width={{ xs: "100%", sm: "auto" }}
                >
                  <Button
                    variant="contained"
                    color="third"
                    onClick={handleFilterClick}
                    startIcon={<FilterAltIcon />}
                    sx={{
                      height: 40,
                      flexGrow: { xs: 1, sm: 0 },
                    }}
                    disabled={loading}
                  >
                    {t("nodeComponents.alarmHistory.filter")}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => fetchHistory(startDate, endDate, selectedEventType)}
                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <RefreshIcon />}
                    sx={{
                      height: 40,
                      flexGrow: { xs: 1, sm: 0 },
                      minWidth: 140,
                    }}
                    disabled={loading}
                  >
                    {t("nodeComponents.alarmHistory.refresh")}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleExportToExcel}
                    startIcon={<FileDownloadIcon />}
                    sx={{
                      height: 40,
                      flexGrow: { xs: 1 },
                      minWidth: 150,
                    }}
                    disabled={loading}
                  >
                    {t("nodeComponents.alarmHistory.export", {
                      defaultValue: "Export",
                    })}
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Box>
      <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" }, mt: 2, mb: 1 }}>
        <FormControl size="small" sx={{ minWidth: 300 }}>
          <InputLabel id="event-type-filter-label">
            {t("nodeComponents.alarmHistory.eventType") || "Olay Tipi"}
          </InputLabel>
          <Select
            labelId="event-type-filter-label"
            value={selectedEventType}
            onChange={(e) => setSelectedEventType(e.target.value)}
            label={t("nodeComponents.alarmHistory.eventType") || "Olay Tipi"}
            MenuProps={{
              PaperProps: {
                style: { maxHeight: 300 },
              },
            }}
          >
            <MenuItem value="">
              <em>{t("nodeComponents.alarmHistory.allEvents") || "Tümü"}</em>
            </MenuItem>
            {EVENT_TYPE_OPTIONS.map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {" "}
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          "& .MuiDataGrid-root": {
            minWidth: "800px",
          },
        }}
      >
        {" "}
        <DataGrid
          columns={columns}
          rows={rows}
          apiRef={apiRef}
          pagination
          loading={loading}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 20 },
            },
          }}
          pageSizeOptions={[20]}
          disableSelectionOnClick
          rowHeight={80} // Use fixed row height instead of auto to avoid ResizeObserver errors
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              textAlign: "center",
              width: "100%",
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal",
              lineHeight: "normal",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              display: "flex",
              padding: "8px",
            },
            "& .MuiDataGrid-columnHeader": {
              justifyContent: "center", // Başlıkları ortalar
              display: "flex",
              alignItems: "center",
            },
            "& .MuiDataGrid-cellContent": {
              margin: "auto", // İçeriği tam merkeze almak için
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          }}
        />
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={hideSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
